<template>
  <base-section id="features-detailed">
    <v-container>
      <div
        style="
          padding-left: 12px;
          padding-right: 12px;
          margin-bottom: 24px;
          display: flex;
          flex-direction: column;
          flex-wrap: nowrap;
          justify-content: flex-start;
          align-items: center;
          align-content: stretch;
        "
      >
        <div class="mb-8">
          <h1 class="mb-4">
            {{
              $t(
                "Finally: TV Series Support (since v1_4_0)"
              )
            }}
          </h1>
          <div>
            <iframe
              width="560"
              height="315"
              src="https://www.youtube-nocookie.com/embed/3qfb5UWJrdQ"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
        </div>

        <div class="mb-8">
          <h1 class="mb-4">
            {{ $t("Exclude Genres Filter (since v1_3_1)") }}
          </h1>
          <div>
            <iframe
              width="560"
              height="315"
              src="https://www.youtube-nocookie.com/embed/Ejcjo6OMRt4"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
        </div>

        <div class="mb-8">
          <h1 class="mb-4">
            {{ $t("Trailer Show feature (since v1_3_0)") }}
          </h1>
          <div>
            <iframe
              width="560"
              height="315"
              src="https://www.youtube-nocookie.com/embed/4p_RNd9xrbA"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
        </div>

        <div class="mb-8">
          <h1 class="mb-4">
            {{ $t("AI recommendations powered by ChatGPT (since v1_1_0)") }}
          </h1>
          <div>
            <iframe
              width="560"
              height="315"
              src="https://www.youtube-nocookie.com/embed/EqiChgd2iuo"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
          <div>
            <iframe
              width="560"
              height="315"
              src="https://www.youtube-nocookie.com/embed/Pi2vfPpOEGQ"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
        </div>

        <div class="mb-8">
          <h1 class="mb-4">
            {{ $t("Overview of the Media Hoarder Features (since v1_0_0)") }}
          </h1>
          <div>
            <iframe
              width="560"
              height="315"
              src="https://www.youtube-nocookie.com/embed/TGkU9e1l8HU"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </div>
    </v-container>
  </base-section>
</template>

<script>
export default {
  name: "SectionFeaturesDetailed",

  data: () => ({}),

  computed: {},

  methods: {},

  /**
   * Lifecycle Hooks
   */
  created() {},
};
</script>
